var render, staticRenderFns
import script from "./ColsRow.vue?vue&type=script&lang=js&"
export * from "./ColsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21ab6fca",
  null
  
)

export default component.exports